import React from "react"
import ChargesTable from "./ChargesTable"
import {useParams} from "react-router-dom"
import {FilterKey} from "types/filter"

const ChargesTab = (props: {profileId?: number; userId?: number}) => {
    const params = useParams<{profileId?: string; userId?: string}>()
    const profileId = props.profileId ?? (params.profileId ? +params.profileId : undefined)
    const userId = props.userId ?? (params.userId ? +params.userId : undefined)

    return (
        <ChargesTable
            profileId={profileId}
            userId={profileId ? undefined : userId}
            filterKey={FilterKey.StudentAccountStudentCharges}
        />
    )
}

export default ChargesTab
